import { Injectable } from '@angular/core';
import { rethrowAsSapError } from 'src/app/lego-utils';
import { map } from 'rxjs/operators';
import { TaskListOperation } from 'src/app/models/domain';
import { TaskListOperationAdapter } from 'src/app/models/domain/adapters';
import { OperationsSetService } from 'src/generated-clients/tasklist';

@Injectable({
  providedIn: 'root',
})
export class OperationDataService {
  private readonly taskListTypePropertyName: keyof TaskListOperation = 'taskListType';
  private readonly taskListGroupPropertyName: keyof TaskListOperation = 'taskListGroup';
  private readonly taskListGroupCounterPropertyName: keyof TaskListOperation = 'groupCounter';

  public constructor(
    private readonly taskListOperationService: OperationsSetService,
    private readonly taskListOperationsAdapter: TaskListOperationAdapter
  ) {}

  public getTaskListOperationByTaskLisGroupAndGroupCounter(
    taskListGroup: string,
    groupCounter: string
  ) {
    const taskListTypeFilter = `${this.taskListTypePropertyName} eq 'Q'`;
    const taskListGroupFilter = `${this.taskListGroupPropertyName} eq '${taskListGroup}'`;
    const taskListGroupCounterFilter = `${this.taskListGroupCounterPropertyName} eq '${groupCounter}'`;

    const filter = `${taskListTypeFilter} and ${taskListGroupFilter} and ${taskListGroupCounterFilter}`;

    return this.taskListOperationService.operationsSetGet(filter).pipe(
      rethrowAsSapError(),
      map((res) => {
        if (!res.d?.results) {
          throw new Error('SAP Error');
        }

        return res.d.results.map((taskListHeader) =>
          this.taskListOperationsAdapter.adaptToDomain(taskListHeader)
        );
      })
    );
  }
}
